'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { CheckIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { ActionLink } from '@src/components/ActionLink/ActionLink';
import { Button } from '@src/components/Button/Button';
import type { SKUSelectionRailItemProps } from '@src/components/SKUSelectionRail/SKUSelectionRailItem/SKUSelectionRailItem.props';
import { SKUSelectionRailItemBorder } from '@src/components/SKUSelectionRail/SKUSelectionRailItem/SKUSelectionRailItemBorder';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
import { cn } from '@src/utils/tailwind';
const SelectButton = t0 => {
  const $ = _c(20);
  const {
    sku,
    railSlug
  } = t0;
  let t1;
  if ($[0] !== railSlug) {
    t1 = state => state.groups.get(railSlug ?? "");
    $[0] = railSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const group = useSKUSelectionStore(t1);
  let t2;
  if ($[2] !== group || $[3] !== sku) {
    t2 = sku ? group?.includes(sku) ?? false : false;
    $[2] = group;
    $[3] = sku;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isSelected = t2;
  const {
    t
  } = useLocale("common");
  if (!sku || !railSlug) {
    return null;
  }
  let t3;
  if ($[5] !== isSelected || $[6] !== t) {
    t3 = !isSelected && t("select").length > 6;
    $[5] = isSelected;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !isSelected;
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = cn({
      "w-full": t3,
      "sm:flex sm:justify-center": t4
    });
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== sku) {
    t6 = {
      sku
    };
    $[11] = sku;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isSelected || $[14] !== t) {
    t7 = isSelected ? <div className="mx-2 flex size-11 items-center justify-center rounded-full bg-bodi-accent-deep-500"><CheckIcon className="size-5 stroke-[2.5px] text-bodi-white" /></div> : <Button size="medium" variant="secondary" className={cn("border-bodi-gray-light hover:border-bodi-black-text hover:bg-transparent", {
      "w-full": t("select").length > 6
    })}>{t("select")}</Button>;
    $[13] = isSelected;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className="mt-3 flex justify-center"><ActionLink className={t5} actionName="selectSKU" selectSKU={t6}>{t7}</ActionLink></div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export const SKUSelectionRailItem = props => {
  const $ = _c(34);
  const {
    imageAlt,
    imageUrl,
    blocks,
    builderBlock,
    sku,
    columnsDesktop,
    imageStyle,
    railSlug,
    analyticsModule
  } = props;
  let t0;
  if ($[0] !== sku) {
    t0 = {
      sku
    };
    $[0] = sku;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = imageStyle === "square";
  const t2 = imageStyle === "horizontal";
  const t3 = imageStyle === "vertical";
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = cn("relative aspect-square", {
      "aspect-square": t1,
      "aspect-250/171": t2,
      "aspect-250/309": t3
    });
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = (columnsDesktop ?? 0) >= 5;
  let t6;
  if ($[6] !== t5) {
    t6 = cn("absolute inset-0 rounded-[13px] bg-bodi-gray-pearl object-cover lg:rounded-[30px]", {
      "lg:rounded-[14px]": t5
    });
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = imageUrl ?? "";
  const t8 = imageAlt ?? "";
  let t9;
  if ($[8] !== t6 || $[9] !== t7 || $[10] !== t8) {
    t9 = <Image className={t6} fill={true} src={t7} alt={t8} />;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== columnsDesktop || $[13] !== railSlug || $[14] !== sku) {
    t10 = <SKUSelectionRailItemBorder columnsDesktop={columnsDesktop} sku={sku} railSlug={railSlug} />;
    $[12] = columnsDesktop;
    $[13] = railSlug;
    $[14] = sku;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t4 || $[18] !== t9) {
    t11 = <div className={t4}>{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t4;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = builderBlock?.id;
  let t13;
  if ($[20] !== blocks || $[21] !== t12) {
    t13 = <BuilderBlocks parentElementId={t12} blocks={blocks} dataPath="component.options.RailPickerItem.blocks" />;
    $[20] = blocks;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== analyticsModule || $[24] !== t0 || $[25] !== t11 || $[26] !== t13) {
    t14 = <ActionLink analyticsModule={analyticsModule} className="relative w-full" actionName="selectSKU" selectSKU={t0}>{t11}{t13}</ActionLink>;
    $[23] = analyticsModule;
    $[24] = t0;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== railSlug || $[29] !== sku) {
    t15 = <SelectButton sku={sku} railSlug={railSlug} />;
    $[28] = railSlug;
    $[29] = sku;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <>{t14}{t15}</>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};